import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import BrandsSection from './components/BrandsSection';
import AdvantagesSection from './components/AdvantagesSection';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-surface font-raleway">
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <BrandsSection />
        <AdvantagesSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
